import React from 'react'
import { useTranslation } from 'react-i18next'
import { FiAlertTriangle } from 'react-icons/fi'
interface ATModuleMessageProps {
  message?: string
  icon?: React.ReactElement
}
const ATModuleMessage: React.FC<ATModuleMessageProps> = (
  props: ATModuleMessageProps,
) => {
  const { t } = useTranslation(['translation'])
  const {
    message = props?.message ? props?.message : t('common.no_data_found'),
    icon = props?.icon ? (
      props?.icon
    ) : (
      <FiAlertTriangle className="icon" size={40} />
    ),
  } = props
  return (
    <div className="d-flex justify-content-center align-items-center loader-container">
      <div className="d-flex align-items-center justify-content-center flex-column flex-grow-1 no-data-container">
        {icon}
        {message}
      </div>
    </div>
  )
}

export default ATModuleMessage
